import { render, staticRenderFns } from "./orderComponent.vue?vue&type=template&id=bd5f6f54"
import script from "./orderComponent.vue?vue&type=script&lang=js"
export * from "./orderComponent.vue?vue&type=script&lang=js"
import style0 from "./orderComponent.vue?vue&type=style&index=0&id=bd5f6f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports